import React from 'react'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { RewardsApplepayIcon, RewardsGpayIcon, RewardsMastercardIcon, RewardsSamsungpayIcon } from 'components/ui-kit/Icons/svg/index'

const VisaIcon = () => (
  <svg width='30' height='20' viewBox='0 0 38 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='38' height='24' rx='3' fill='#1434CB' />
    <path d='M15.4 16.5L17.3 6.8H19.9L18 16.5H15.4ZM25.3 7C24.8 6.8 24 6.6 23 6.6C20.6 6.6 18.9 7.8 18.9 9.5C18.9 10.8 20.1 11.5 21 11.9C21.9 12.3 22.2 12.6 22.2 13C22.2 13.6 21.5 13.9 20.7 13.9C19.7 13.9 19.1 13.7 18.4 13.4L18 15.3C18.7 15.6 19.8 15.9 20.9 15.9C23.5 15.9 25.2 14.6 25.2 12.8C25.2 11.2 24.2 10.5 23 10C22.3 9.6 21.9 9.3 21.9 8.9C21.9 8.5 22.4 8.2 23.2 8.2C24 8.2 24.7 8.4 25.1 8.6L25.3 7ZM30.5 16.5H32.8L30.8 6.8H28.7C28.2 6.8 27.8 7.1 27.6 7.5L23.7 16.5H26.4L26.9 15H30.2L30.5 16.5ZM27.7 13.1L29 9.4L29.8 13.1H27.7ZM13.6 6.8L11.1 13.4L10.8 11.9C10.3 10.3 8.9 8.6 7.2 7.7L9.5 16.5H12.2L16.3 6.8H13.6Z' fill='white' />
  </svg>
)

const BTN_BASE =
  'inline-flex min-h-11 min-w-[120px] cursor-pointer items-center justify-center whitespace-nowrap ' +
  'rounded-lg px-6 py-1 text-base font-medium uppercase leading-[1.688rem] text-white shadow-none ' +
  'transition-all duration-300 active:scale-[0.98] active:opacity-80 ' +
  'max-lg:text-sm max-md:min-h-10 max-md:min-w-[106px] max-md:text-base ' +
  'max-sm:min-h-8 max-sm:min-w-0 max-sm:px-3 max-sm:py-2 max-sm:text-sm max-sm:leading-4 ' +
  'max-[600px]:w-full'

const BTN_PRIMARY_GOLD =
  `${BTN_BASE} border-0 bg-[linear-gradient(#EFD43C,#CB7D00)] text-[var(--gray-20)] ` +
  'hover:bg-[linear-gradient(#EFD43C,#CB7D00)] focus:bg-[linear-gradient(#EFD43C,#CB7D00)]'

const BTN_SECONDARY =
  `${BTN_BASE} border-0 bg-[linear-gradient(#EFD43C,#CB7D00)] ` +
  'hover:bg-[linear-gradient(#EFD43C,#CB7D00)] focus:bg-[linear-gradient(#EFD43C,#CB7D00)] ' +
  'active:bg-[linear-gradient(#EFD43C,#CB7D00)] active:text-white ' +
  'disabled:bg-[linear-gradient(#EFD43C,#CB7D00)] disabled:text-white disabled:opacity-50'

const DepositBuyCrypto = (props) => {
  const { t } = useTranslation()
  const { currencyName, buttonType, showOnramperWidget, currencyCode } = props

  const buttonClass = buttonType === 'secondary'
    ? BTN_SECONDARY
    : BTN_PRIMARY_GOLD

  return (
    <div className='mt-1 rounded-[0.625rem] p-6 text-[var(--gray-20)] max-md:p-4 md:flex md:items-center md:justify-between'>
      <div className='flex items-center max-md:flex-col'>
        <h4 className='my-0 text-base font-medium leading-relaxed text-[var(--gray-20)] max-md:mb-6'>
          {t('doNotHaveAnyCurrency', {
            currency: currencyName
          })}
        </h4>
      </div>
      <div className='flex items-center max-md:justify-center [&_a]:mx-1 [&_svg]:mx-1 [&_svg]:max-h-6 [&_svg]:max-w-[2.875rem]'>
        <NavLink to='#'>
          <RewardsSamsungpayIcon />
        </NavLink>
        <NavLink to='#'>
          <VisaIcon />
        </NavLink>
        <NavLink to='#'>
          <RewardsMastercardIcon style={{ width: '30px' }} />
        </NavLink>
        <NavLink to='#'>
          <RewardsApplepayIcon />
        </NavLink>
        <NavLink to='#'>
          <RewardsGpayIcon />
        </NavLink>
      </div>
      <div className='text-center max-md:mt-6'>
        <button
          type='button'
          className={buttonClass}
          onClick={() => showOnramperWidget(currencyCode)}
        >
          {t('buyCrypto')}
        </button>
      </div>
    </div>
  )
}

export default React.memo(DepositBuyCrypto)
